import { AfterViewInit, Directive, ElementRef, HostListener, Input } from '@angular/core'

@Directive({
  selector: '[appDynamicFontSize]'
})
export class DynamicFontSizeDirective implements AfterViewInit {
  @Input() minFontSize = 10;
  @Input() maxFontSize = 16;

  @HostListener('window:resize')
  onWindowResize(): void {
    this.resizeText();
  }

  constructor(private el: ElementRef) {
  }

  ngAfterViewInit(): void {
    this.resizeText();
  }

  private resizeText(): void {
    const element = this.el.nativeElement;
    let fontSize = this.maxFontSize;
    element.style.fontSize = fontSize + 'px';
    while (
      this.getParentWidth() > 0 &&
      this.getParentHeight() > 0 &&
      fontSize > this.minFontSize &&
      (element.scrollWidth > this.getParentWidth() || element.scrollHeight > this.getParentHeight())
    ) {
      fontSize--;
      element.style.fontSize = fontSize + 'px';
    }
  }

  private getParentWidth(): number {
    const parent = this.el.nativeElement.parentElement;
    const paddingLeft = parseFloat(window.getComputedStyle(parent, null).getPropertyValue('padding-left'));
    const paddingRight = parseFloat(window.getComputedStyle(parent, null).getPropertyValue('padding-right'));
    return parent.clientWidth - paddingLeft - paddingRight;
  }

  private getParentHeight(): number {
    const parent = this.el.nativeElement.parentElement;
    const paddingTop = parseFloat(window.getComputedStyle(parent, null).getPropertyValue('padding-top'));
    const paddingBottom = parseFloat(window.getComputedStyle(parent, null).getPropertyValue('padding-bottom'));
    return parent.clientHeight - paddingTop - paddingBottom;
  }
}
